import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';

@Module({ namespaced: true })
class Settings extends VuexModule {
  public colorMode: 'light' | 'dark' = 'light';
  public transition: 'translate-up' | 'translate-down' = 'translate-down';

  @Mutation
  public setTransition(transition: 'translate-up' | 'translate-down') {
    this.transition = transition;
  }

  @Mutation
  public setColorMode(mode: 'light' | 'dark') {
    this.colorMode = mode;
  }
}
export default Settings;

